import { RequireChildrenFor } from "@omni/types/components/utils/children.types";

type BaseProps = RequireChildrenFor<{}>;

const Base = ({ children }: BaseProps) => {
    return <>{children}</>;
};

export { Base };
